import React from 'react';
import './AiStack.css';

const logos = [
    { src: "/claude.png", alt: "Claude API logo" },
    { src: "/openai.png", alt: "OpenAI logo" },
    { src: "/langchain.png", alt: "LangChain logo" },
    { src: "/langgraph.png", alt: "LangGraph logo" },
    { src: "/autogen.png", alt: "AutoGen logo" },
    { src: "/crewai.png", alt: "CrewAI logo" },
    { src: "/pinecone.png", alt: "Pinecone logo" },
    { src: "/n8n.png", alt: "n8n logo" },
    { src: "/make.png", alt: "Make logo" },
    { src: "/elevenlabs.png", alt: "ElevenLabs logo" },
    { src: "/fastapi.png", alt: "FastAPI logo" },
    { src: "/react.png", alt: "React logo" },
    { src: "/html.png", alt: "HTML logo" },
    { src: "/css.png", alt: "CSS logo" },
    { src: "/nodejs.png", alt: "Node.js logo" },
    { src: "/php.png", alt: "PHP logo" },
    { src: "/figma.png", alt: "Figma logo" },
    { src: "/adobexd.png", alt: "Adobe XD logo" },
    { src: "/android.png", alt: "Android logo" },
    { src: "/flutter.png", alt: "Flutter logo" },
    { src: "/swift.png", alt: "Swift logo" },
    { src: "/photoshop.png", alt: "Photoshop logo" },
    { src: "/illustrator.png", alt: "Illustrator logo" },
    { src: "/aftereffects.png", alt: "After Effects logo" },
    { src: "/canva.png", alt: "Canva logo" },
];

const AIStack = () => {
    return (
        <section id="ai-stack-page" className="ai-stack" aria-label="Our AI Tech Stack">
            <h2 className="ai-stack__heading">Our AI Tech Stack</h2>
            <p className="ai-stack__subheading">We work with the leading AI platforms, orchestration frameworks, and deployment tools in the agentic ecosystem.</p>
            <div className="ai-stack__viewport">
                <div className="ai-stack__track">
                    {[...logos, ...logos].map((l, i) => (
                        <img
                            key={i}
                            src={l.src}
                            alt={l.alt}
                            className="ai-stack__logo"
                            loading="lazy"
                            width="120"
                            height="60"
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AIStack;
